import actionCreator from "helpers/actionCreator"
import { createReducer } from "reduxsauce"
import { toUpper } from "lodash"

export const { Types, Creators } = actionCreator("ompnt/modules/security-profile/", {
  toggleWatchlistsMenu: [],
  setBase: ["baseType", "id", "name"],
  setSecurityBase: ["assetClass", "ticker", "mic"],
  removeBase: [],
  setDisplayType: {
    props: ["displayType"],
    track: true,
    trackType: "security-profile-tab-switch",
  },
  trackCSVDownload: {
    track: true,
    trackType: "security-profile-graph-timeseries-download",
  },
})

const DEFAULT_STATE = {
  watchlistsMenuVisible: false,
  displayType: null,
  base: null,
  baseName: null,
}

function handleToggleWatchlistsMenu(state) {
  return { ...state, watchlistsMenuVisible: !state.watchlistsMenuVisible }
}

function handleSetSecurityBase(state, { assetClass, ticker, mic }) {
  return {
    ...state,
    base: { type: "security", assetClass, ticker, mic },
    baseName: null,
  }
}

function handleSetBase(state, { baseType, id, name }) {
  return {
    ...state,
    base: { type: toUpper(baseType), id },
    baseName: name,
  }
}

function handleRemoveBase(state) {
  return {
    ...state,
    base: null,
    baseName: null,
  }
}

function handleSetDisplayType(state, { displayType }) {
  return { ...state, displayType }
}

export default createReducer(DEFAULT_STATE, {
  [Types.TOGGLE_WATCHLISTS_MENU]: handleToggleWatchlistsMenu,
  [Types.SET_SECURITY_BASE]: handleSetSecurityBase,
  [Types.REMOVE_BASE]: handleRemoveBase,
  [Types.SET_DISPLAY_TYPE]: handleSetDisplayType,
  [Types.SET_BASE]: handleSetBase,
})
